import {
  SET_LOGGED_IN_USER,
  SET_IS_AUTHENTICATED,
  SET_IS_AUTHENTICATING
} from '../actionTypes';

const initialState = {
  user: {
    userInfo: {},
    isAuthenticated: false,
    isAuthenticating: false
  }
};

function rootReducer(state = initialState, action) {
  if (action.type === SET_LOGGED_IN_USER) {
    return Object.assign({}, state, {
      user: {
        ...state.user,
        userInfo: action.payload,
        isAuthenticated: true
      }
    });
  }

  if (action.type === SET_IS_AUTHENTICATED) {
    return Object.assign({}, state, {
      user: {
        ...state.user,
        isAuthenticated: action.payload
      }
    });
  }

  if (action.type === SET_IS_AUTHENTICATING) {
    return Object.assign({}, state, {
      user: {
        ...state.user,
        isAuthenticating: action.payload
      }
    });
  }

  return state;
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js